import React from 'react';

export const CopytradingQr = () => {
  return (
    <svg
      width="116"
      height="116"
      viewBox="0 0 116 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="116" height="116" rx="8" fill="white" />
      <rect x="6" y="6" width="104" height="104" rx="4" fill="white" />
      <path d="M39.7288 6H36.918V8.81081H39.7288V6Z" fill="black" />
      <path d="M45.3518 6H42.541V8.81081H45.3518V6Z" fill="black" />
      <path d="M48.1624 6H45.3516V8.81081H48.1624V6Z" fill="black" />
      <path d="M50.9729 6H48.1621V8.81081H50.9729V6Z" fill="black" />
      <path d="M53.7835 6H50.9727V8.81081H53.7835V6Z" fill="black" />
      <path d="M56.594 6H53.7832V8.81081H56.594V6Z" fill="black" />
      <path d="M62.2171 6H59.4062V8.81081H62.2171V6Z" fill="black" />
      <path d="M65.0276 6H62.2168V8.81081H65.0276V6Z" fill="black" />
      <path d="M73.4592 6H70.6484V8.81081H73.4592V6Z" fill="black" />
      <path d="M76.2698 6H73.459V8.81081H76.2698V6Z" fill="black" />
      <path d="M79.0803 6H76.2695V8.81081H79.0803V6Z" fill="black" />
      <path d="M87.5139 6H84.7031V8.81081H87.5139V6Z" fill="black" />
      <path
        d="M34.1077 8.81055H31.2969V11.6214H34.1077V8.81055Z"
        fill="black"
      />
      <path
        d="M36.9202 8.81055H34.1094V11.6214H36.9202V8.81055Z"
        fill="black"
      />
      <path d="M39.7288 8.81055H36.918V11.6214H39.7288V8.81055Z" fill="black" />
      <path
        d="M42.5413 8.81055H39.7305V11.6214H42.5413V8.81055Z"
        fill="black"
      />
      <path d="M45.3518 8.81055H42.541V11.6214H45.3518V8.81055Z" fill="black" />
      <path
        d="M59.4046 8.81055H56.5938V11.6214H59.4046V8.81055Z"
        fill="black"
      />
      <path
        d="M65.0276 8.81055H62.2168V11.6214H65.0276V8.81055Z"
        fill="black"
      />
      <path
        d="M70.6487 8.81055H67.8379V11.6214H70.6487V8.81055Z"
        fill="black"
      />
      <path
        d="M73.4592 8.81055H70.6484V11.6214H73.4592V8.81055Z"
        fill="black"
      />
      <path
        d="M79.0803 8.81055H76.2695V11.6214H79.0803V8.81055Z"
        fill="black"
      />
      <path d="M36.9202 11.625H34.1094V14.4358H36.9202V11.625Z" fill="black" />
      <path d="M39.7288 11.625H36.918V14.4358H39.7288V11.625Z" fill="black" />
      <path d="M42.5413 11.625H39.7305V14.4358H42.5413V11.625Z" fill="black" />
      <path d="M53.7835 11.625H50.9727V14.4358H53.7835V11.625Z" fill="black" />
      <path d="M56.594 11.625H53.7832V14.4358H56.594V11.625Z" fill="black" />
      <path d="M67.8382 11.625H65.0273V14.4358H67.8382V11.625Z" fill="black" />
      <path d="M70.6487 11.625H67.8379V14.4358H70.6487V11.625Z" fill="black" />
      <path d="M73.4592 11.625H70.6484V14.4358H73.4592V11.625Z" fill="black" />
      <path d="M76.2698 11.625H73.459V14.4358H76.2698V11.625Z" fill="black" />
      <path d="M79.0803 11.625H76.2695V14.4358H79.0803V11.625Z" fill="black" />
      <path d="M81.8928 11.625H79.082V14.4358H81.8928V11.625Z" fill="black" />
      <path d="M84.7014 11.625H81.8906V14.4358H84.7014V11.625Z" fill="black" />
      <path
        d="M36.9202 14.4316H34.1094V17.2424H36.9202V14.4316Z"
        fill="black"
      />
      <path d="M39.7288 14.4316H36.918V17.2424H39.7288V14.4316Z" fill="black" />
      <path
        d="M42.5413 14.4316H39.7305V17.2424H42.5413V14.4316Z"
        fill="black"
      />
      <path d="M45.3518 14.4316H42.541V17.2424H45.3518V14.4316Z" fill="black" />
      <path
        d="M50.9729 14.4316H48.1621V17.2424H50.9729V14.4316Z"
        fill="black"
      />
      <path
        d="M67.8382 14.4316H65.0273V17.2424H67.8382V14.4316Z"
        fill="black"
      />
      <path
        d="M70.6487 14.4316H67.8379V17.2424H70.6487V14.4316Z"
        fill="black"
      />
      <path
        d="M79.0803 14.4316H76.2695V17.2424H79.0803V14.4316Z"
        fill="black"
      />
      <path
        d="M81.8909 14.4316H79.0801V17.2424H81.8909V14.4316Z"
        fill="black"
      />
      <path
        d="M31.2971 17.2461H28.4863V20.0569H31.2971V17.2461Z"
        fill="black"
      />
      <path
        d="M36.9202 17.2461H34.1094V20.0569H36.9202V17.2461Z"
        fill="black"
      />
      <path d="M39.7288 17.2461H36.918V20.0569H39.7288V17.2461Z" fill="black" />
      <path d="M45.3518 17.2461H42.541V20.0569H45.3518V17.2461Z" fill="black" />
      <path
        d="M48.1624 17.2461H45.3516V20.0569H48.1624V17.2461Z"
        fill="black"
      />
      <path
        d="M50.9729 17.2461H48.1621V20.0569H50.9729V17.2461Z"
        fill="black"
      />
      <path
        d="M53.7835 17.2461H50.9727V20.0569H53.7835V17.2461Z"
        fill="black"
      />
      <path d="M56.594 17.2461H53.7832V20.0569H56.594V17.2461Z" fill="black" />
      <path
        d="M59.4046 17.2461H56.5938V20.0569H59.4046V17.2461Z"
        fill="black"
      />
      <path
        d="M65.0276 17.2461H62.2168V20.0569H65.0276V17.2461Z"
        fill="black"
      />
      <path
        d="M73.4592 17.2461H70.6484V20.0569H73.4592V17.2461Z"
        fill="black"
      />
      <path d="M76.2698 17.2461H73.459V20.0569H76.2698V17.2461Z" fill="black" />
      <path
        d="M81.8909 17.2461H79.0801V20.0569H81.8909V17.2461Z"
        fill="black"
      />
      <path
        d="M84.7014 17.2461H81.8906V20.0569H84.7014V17.2461Z"
        fill="black"
      />
      <path
        d="M34.1077 20.0566H31.2969V22.8674H34.1077V20.0566Z"
        fill="black"
      />
      <path
        d="M50.9729 20.0566H48.1621V22.8674H50.9729V20.0566Z"
        fill="black"
      />
      <path
        d="M59.4046 20.0566H56.5938V22.8674H59.4046V20.0566Z"
        fill="black"
      />
      <path
        d="M62.2171 20.0566H59.4062V22.8674H62.2171V20.0566Z"
        fill="black"
      />
      <path d="M76.2698 20.0566H73.459V22.8674H76.2698V20.0566Z" fill="black" />
      <path
        d="M79.0803 20.0566H76.2695V22.8674H79.0803V20.0566Z"
        fill="black"
      />
      <path
        d="M31.2971 22.8633H28.4863V25.6741H31.2971V22.8633Z"
        fill="black"
      />
      <path
        d="M36.9202 22.8633H34.1094V25.6741H36.9202V22.8633Z"
        fill="black"
      />
      <path
        d="M42.5413 22.8633H39.7305V25.6741H42.5413V22.8633Z"
        fill="black"
      />
      <path
        d="M48.1624 22.8633H45.3516V25.6741H48.1624V22.8633Z"
        fill="black"
      />
      <path
        d="M53.7835 22.8633H50.9727V25.6741H53.7835V22.8633Z"
        fill="black"
      />
      <path
        d="M59.4046 22.8633H56.5938V25.6741H59.4046V22.8633Z"
        fill="black"
      />
      <path
        d="M65.0276 22.8633H62.2168V25.6741H65.0276V22.8633Z"
        fill="black"
      />
      <path
        d="M70.6487 22.8633H67.8379V25.6741H70.6487V22.8633Z"
        fill="black"
      />
      <path d="M76.2698 22.8633H73.459V25.6741H76.2698V22.8633Z" fill="black" />
      <path
        d="M81.8909 22.8633H79.0801V25.6741H81.8909V22.8633Z"
        fill="black"
      />
      <path
        d="M87.5139 22.8633H84.7031V25.6741H87.5139V22.8633Z"
        fill="black"
      />
      <path
        d="M31.2971 25.6738H28.4863V28.4846H31.2971V25.6738Z"
        fill="black"
      />
      <path
        d="M34.1077 25.6738H31.2969V28.4846H34.1077V25.6738Z"
        fill="black"
      />
      <path d="M39.7288 25.6738H36.918V28.4846H39.7288V25.6738Z" fill="black" />
      <path
        d="M48.1624 25.6738H45.3516V28.4846H48.1624V25.6738Z"
        fill="black"
      />
      <path
        d="M50.9729 25.6738H48.1621V28.4846H50.9729V25.6738Z"
        fill="black"
      />
      <path
        d="M53.7835 25.6738H50.9727V28.4846H53.7835V25.6738Z"
        fill="black"
      />
      <path d="M56.594 25.6738H53.7832V28.4846H56.594V25.6738Z" fill="black" />
      <path d="M76.2698 25.6738H73.459V28.4846H76.2698V25.6738Z" fill="black" />
      <path
        d="M84.7014 25.6738H81.8906V28.4846H84.7014V25.6738Z"
        fill="black"
      />
      <path
        d="M87.5139 25.6738H84.7031V28.4846H87.5139V25.6738Z"
        fill="black"
      />
      <path
        d="M14.4319 28.4883H11.6211V31.2991H14.4319V28.4883Z"
        fill="black"
      />
      <path
        d="M17.2424 28.4883H14.4316V31.2991H17.2424V28.4883Z"
        fill="black"
      />
      <path d="M25.676 28.4883H22.8652V31.2991H25.676V28.4883Z" fill="black" />
      <path
        d="M28.4866 28.4883H25.6758V31.2991H28.4866V28.4883Z"
        fill="black"
      />
      <path
        d="M31.2971 28.4883H28.4863V31.2991H31.2971V28.4883Z"
        fill="black"
      />
      <path
        d="M34.1077 28.4883H31.2969V31.2991H34.1077V28.4883Z"
        fill="black"
      />
      <path
        d="M36.9202 28.4883H34.1094V31.2991H36.9202V28.4883Z"
        fill="black"
      />
      <path d="M39.7288 28.4883H36.918V31.2991H39.7288V28.4883Z" fill="black" />
      <path
        d="M42.5413 28.4883H39.7305V31.2991H42.5413V28.4883Z"
        fill="black"
      />
      <path d="M45.3518 28.4883H42.541V31.2991H45.3518V28.4883Z" fill="black" />
      <path d="M56.594 28.4883H53.7832V31.2991H56.594V28.4883Z" fill="black" />
      <path
        d="M62.2171 28.4883H59.4062V31.2991H62.2171V28.4883Z"
        fill="black"
      />
      <path
        d="M67.8382 28.4883H65.0273V31.2991H67.8382V28.4883Z"
        fill="black"
      />
      <path
        d="M73.4592 28.4883H70.6484V31.2991H73.4592V28.4883Z"
        fill="black"
      />
      <path
        d="M79.0803 28.4883H76.2695V31.2991H79.0803V28.4883Z"
        fill="black"
      />
      <path
        d="M84.7014 28.4883H81.8906V31.2991H84.7014V28.4883Z"
        fill="black"
      />
      <path
        d="M87.5139 28.4883H84.7031V31.2991H87.5139V28.4883Z"
        fill="black"
      />
      <path
        d="M90.3245 28.4883H87.5137V31.2991H90.3245V28.4883Z"
        fill="black"
      />
      <path d="M93.135 28.4883H90.3242V31.2991H93.135V28.4883Z" fill="black" />
      <path
        d="M98.7561 28.4883H95.9453V31.2991H98.7561V28.4883Z"
        fill="black"
      />
      <path
        d="M22.8655 31.2988H20.0547V34.1096H22.8655V31.2988Z"
        fill="black"
      />
      <path
        d="M28.4866 31.2988H25.6758V34.1096H28.4866V31.2988Z"
        fill="black"
      />
      <path
        d="M34.1077 31.2988H31.2969V34.1096H34.1077V31.2988Z"
        fill="black"
      />
      <path
        d="M36.9182 31.2988H34.1074V34.1096H36.9182V31.2988Z"
        fill="black"
      />
      <path
        d="M48.1624 31.2988H45.3516V34.1096H48.1624V31.2988Z"
        fill="black"
      />
      <path
        d="M50.9729 31.2988H48.1621V34.1096H50.9729V31.2988Z"
        fill="black"
      />
      <path
        d="M53.7835 31.2988H50.9727V34.1096H53.7835V31.2988Z"
        fill="black"
      />
      <path
        d="M59.4046 31.2988H56.5938V34.1096H59.4046V31.2988Z"
        fill="black"
      />
      <path
        d="M62.2171 31.2988H59.4062V34.1096H62.2171V31.2988Z"
        fill="black"
      />
      <path
        d="M67.8382 31.2988H65.0273V34.1096H67.8382V31.2988Z"
        fill="black"
      />
      <path d="M76.2698 31.2988H73.459V34.1096H76.2698V31.2988Z" fill="black" />
      <path
        d="M79.0803 31.2988H76.2695V34.1096H79.0803V31.2988Z"
        fill="black"
      />
      <path d="M81.8928 31.2988H79.082V34.1096H81.8928V31.2988Z" fill="black" />
      <path
        d="M84.7034 31.2988H81.8926V34.1096H84.7034V31.2988Z"
        fill="black"
      />
      <path
        d="M87.5139 31.2988H84.7031V34.1096H87.5139V31.2988Z"
        fill="black"
      />
      <path
        d="M90.3245 31.2988H87.5137V34.1096H90.3245V31.2988Z"
        fill="black"
      />
      <path d="M93.135 31.2988H90.3242V34.1096H93.135V31.2988Z" fill="black" />
      <path
        d="M101.567 31.2988H98.7559V34.1096H101.567V31.2988Z"
        fill="black"
      />
      <path
        d="M104.379 31.2988H101.568V34.1096H104.379V31.2988Z"
        fill="black"
      />
      <path d="M107.19 31.2988H104.379V34.1096H107.19V31.2988Z" fill="black" />
      <path
        d="M11.6214 34.1094H8.81055V36.9202H11.6214V34.1094Z"
        fill="black"
      />
      <path
        d="M17.2424 34.1094H14.4316V36.9202H17.2424V34.1094Z"
        fill="black"
      />
      <path d="M20.053 34.1094H17.2422V36.9202H20.053V34.1094Z" fill="black" />
      <path d="M25.676 34.1094H22.8652V36.9202H25.676V34.1094Z" fill="black" />
      <path
        d="M28.4866 34.1094H25.6758V36.9202H28.4866V34.1094Z"
        fill="black"
      />
      <path
        d="M31.2971 34.1094H28.4863V36.9202H31.2971V34.1094Z"
        fill="black"
      />
      <path
        d="M42.5413 34.1094H39.7305V36.9202H42.5413V34.1094Z"
        fill="black"
      />
      <path d="M45.3518 34.1094H42.541V36.9202H45.3518V34.1094Z" fill="black" />
      <path
        d="M48.1624 34.1094H45.3516V36.9202H48.1624V34.1094Z"
        fill="black"
      />
      <path
        d="M53.7835 34.1094H50.9727V36.9202H53.7835V34.1094Z"
        fill="black"
      />
      <path d="M56.594 34.1094H53.7832V36.9202H56.594V34.1094Z" fill="black" />
      <path
        d="M59.4046 34.1094H56.5938V36.9202H59.4046V34.1094Z"
        fill="black"
      />
      <path
        d="M62.2171 34.1094H59.4062V36.9202H62.2171V34.1094Z"
        fill="black"
      />
      <path
        d="M65.0276 34.1094H62.2168V36.9202H65.0276V34.1094Z"
        fill="black"
      />
      <path
        d="M67.8382 34.1094H65.0273V36.9202H67.8382V34.1094Z"
        fill="black"
      />
      <path d="M76.2698 34.1094H73.459V36.9202H76.2698V34.1094Z" fill="black" />
      <path
        d="M79.0803 34.1094H76.2695V36.9202H79.0803V34.1094Z"
        fill="black"
      />
      <path
        d="M84.7014 34.1094H81.8906V36.9202H84.7014V34.1094Z"
        fill="black"
      />
      <path
        d="M90.3245 34.1094H87.5137V36.9202H90.3245V34.1094Z"
        fill="black"
      />
      <path
        d="M95.9456 34.1094H93.1348V36.9202H95.9456V34.1094Z"
        fill="black"
      />
      <path
        d="M98.7561 34.1094H95.9453V36.9202H98.7561V34.1094Z"
        fill="black"
      />
      <path d="M11.6214 36.916H8.81055V39.7268H11.6214V36.916Z" fill="black" />
      <path d="M14.4319 36.916H11.6211V39.7268H14.4319V36.916Z" fill="black" />
      <path d="M17.2424 36.916H14.4316V39.7268H17.2424V36.916Z" fill="black" />
      <path d="M31.2971 36.916H28.4863V39.7268H31.2971V36.916Z" fill="black" />
      <path d="M34.1077 36.916H31.2969V39.7268H34.1077V36.916Z" fill="black" />
      <path d="M42.5413 36.916H39.7305V39.7268H42.5413V36.916Z" fill="black" />
      <path d="M50.9729 36.916H48.1621V39.7268H50.9729V36.916Z" fill="black" />
      <path d="M56.594 36.916H53.7832V39.7268H56.594V36.916Z" fill="black" />
      <path d="M65.0276 36.916H62.2168V39.7268H65.0276V36.916Z" fill="black" />
      <path d="M70.6487 36.916H67.8379V39.7268H70.6487V36.916Z" fill="black" />
      <path d="M73.4592 36.916H70.6484V39.7268H73.4592V36.916Z" fill="black" />
      <path d="M76.2698 36.916H73.459V39.7268H76.2698V36.916Z" fill="black" />
      <path d="M79.0803 36.916H76.2695V39.7268H79.0803V36.916Z" fill="black" />
      <path d="M81.8909 36.916H79.0801V39.7268H81.8909V36.916Z" fill="black" />
      <path d="M84.7014 36.916H81.8906V39.7268H84.7014V36.916Z" fill="black" />
      <path d="M95.9456 36.916H93.1348V39.7268H95.9456V36.916Z" fill="black" />
      <path d="M101.569 36.916H98.7578V39.7268H101.569V36.916Z" fill="black" />
      <path d="M104.379 36.916H101.568V39.7268H104.379V36.916Z" fill="black" />
      <path d="M107.19 36.916H104.379V39.7268H107.19V36.916Z" fill="black" />
      <path
        d="M11.6214 39.7324H8.81055V42.5432H11.6214V39.7324Z"
        fill="black"
      />
      <path
        d="M22.8655 39.7324H20.0547V42.5432H22.8655V39.7324Z"
        fill="black"
      />
      <path d="M25.676 39.7324H22.8652V42.5432H25.676V39.7324Z" fill="black" />
      <path
        d="M28.4866 39.7324H25.6758V42.5432H28.4866V39.7324Z"
        fill="black"
      />
      <path
        d="M31.2971 39.7324H28.4863V42.5432H31.2971V39.7324Z"
        fill="black"
      />
      <path
        d="M36.9202 39.7324H34.1094V42.5432H36.9202V39.7324Z"
        fill="black"
      />
      <path d="M39.7288 39.7324H36.918V42.5432H39.7288V39.7324Z" fill="black" />
      <path
        d="M42.5413 39.7324H39.7305V42.5432H42.5413V39.7324Z"
        fill="black"
      />
      <path
        d="M48.1624 39.7324H45.3516V42.5432H48.1624V39.7324Z"
        fill="black"
      />
      <path
        d="M50.9729 39.7324H48.1621V42.5432H50.9729V39.7324Z"
        fill="black"
      />
      <path
        d="M53.7835 39.7324H50.9727V42.5432H53.7835V39.7324Z"
        fill="black"
      />
      <path
        d="M59.4046 39.7324H56.5938V42.5432H59.4046V39.7324Z"
        fill="black"
      />
      <path
        d="M65.0276 39.7324H62.2168V42.5432H65.0276V39.7324Z"
        fill="black"
      />
      <path
        d="M67.8382 39.7324H65.0273V42.5432H67.8382V39.7324Z"
        fill="black"
      />
      <path
        d="M79.0803 39.7324H76.2695V42.5432H79.0803V39.7324Z"
        fill="black"
      />
      <path
        d="M81.8909 39.7324H79.0801V42.5432H81.8909V39.7324Z"
        fill="black"
      />
      <path
        d="M90.3245 39.7324H87.5137V42.5432H90.3245V39.7324Z"
        fill="black"
      />
      <path d="M93.135 39.7324H90.3242V42.5432H93.135V39.7324Z" fill="black" />
      <path
        d="M95.9456 39.7324H93.1348V42.5432H95.9456V39.7324Z"
        fill="black"
      />
      <path
        d="M98.7561 39.7324H95.9453V42.5432H98.7561V39.7324Z"
        fill="black"
      />
      <path
        d="M101.569 39.7324H98.7578V42.5432H101.569V39.7324Z"
        fill="black"
      />
      <path
        d="M104.379 39.7324H101.568V42.5432H104.379V39.7324Z"
        fill="black"
      />
      <path d="M110 39.7324H107.189V42.5432H110V39.7324Z" fill="black" />
      <path d="M8.81081 42.541H6V45.3518H8.81081V42.541Z" fill="black" />
      <path d="M14.4319 42.541H11.6211V45.3518H14.4319V42.541Z" fill="black" />
      <path d="M17.2424 42.541H14.4316V45.3518H17.2424V42.541Z" fill="black" />
      <path d="M31.2971 42.541H28.4863V45.3518H31.2971V42.541Z" fill="black" />
      <path d="M34.1077 42.541H31.2969V45.3518H34.1077V42.541Z" fill="black" />
      <path d="M39.7307 42.541H36.9199V45.3518H39.7307V42.541Z" fill="black" />
      <path d="M42.5413 42.541H39.7305V45.3518H42.5413V42.541Z" fill="black" />
      <path d="M56.594 42.541H53.7832V45.3518H56.594V42.541Z" fill="black" />
      <path d="M59.4046 42.541H56.5938V45.3518H59.4046V42.541Z" fill="black" />
      <path d="M70.6487 42.541H67.8379V45.3518H70.6487V42.541Z" fill="black" />
      <path d="M73.4592 42.541H70.6484V45.3518H73.4592V42.541Z" fill="black" />
      <path d="M81.8928 42.541H79.082V45.3518H81.8928V42.541Z" fill="black" />
      <path d="M84.7014 42.541H81.8906V45.3518H84.7014V42.541Z" fill="black" />
      <path d="M87.5139 42.541H84.7031V45.3518H87.5139V42.541Z" fill="black" />
      <path d="M93.135 42.541H90.3242V45.3518H93.135V42.541Z" fill="black" />
      <path d="M95.9456 42.541H93.1348V45.3518H95.9456V42.541Z" fill="black" />
      <path d="M98.7561 42.541H95.9453V45.3518H98.7561V42.541Z" fill="black" />
      <path d="M104.379 42.541H101.568V45.3518H104.379V42.541Z" fill="black" />
      <path d="M110 42.541H107.189V45.3518H110V42.541Z" fill="black" />
      <path
        d="M11.6214 45.3516H8.81055V48.1624H11.6214V45.3516Z"
        fill="black"
      />
      <path
        d="M14.4319 45.3516H11.6211V48.1624H14.4319V45.3516Z"
        fill="black"
      />
      <path
        d="M17.2424 45.3516H14.4316V48.1624H17.2424V45.3516Z"
        fill="black"
      />
      <path d="M20.053 45.3516H17.2422V48.1624H20.053V45.3516Z" fill="black" />
      <path d="M25.676 45.3516H22.8652V48.1624H25.676V45.3516Z" fill="black" />
      <path
        d="M28.4866 45.3516H25.6758V48.1624H28.4866V45.3516Z"
        fill="black"
      />
      <path
        d="M31.2971 45.3516H28.4863V48.1624H31.2971V45.3516Z"
        fill="black"
      />
      <path
        d="M34.1077 45.3516H31.2969V48.1624H34.1077V45.3516Z"
        fill="black"
      />
      <path
        d="M48.1624 45.3516H45.3516V48.1624H48.1624V45.3516Z"
        fill="black"
      />
      <path
        d="M59.4046 45.3516H56.5938V48.1624H59.4046V45.3516Z"
        fill="black"
      />
      <path
        d="M65.0276 45.3516H62.2168V48.1624H65.0276V45.3516Z"
        fill="black"
      />
      <path
        d="M67.8382 45.3516H65.0273V48.1624H67.8382V45.3516Z"
        fill="black"
      />
      <path d="M76.2698 45.3516H73.459V48.1624H76.2698V45.3516Z" fill="black" />
      <path
        d="M81.8909 45.3516H79.0801V48.1624H81.8909V45.3516Z"
        fill="black"
      />
      <path
        d="M104.379 45.3516H101.568V48.1624H104.379V45.3516Z"
        fill="black"
      />
      <path d="M107.19 45.3516H104.379V48.1624H107.19V45.3516Z" fill="black" />
      <path d="M8.81081 48.1641H6V50.9749H8.81081V48.1641Z" fill="black" />
      <path
        d="M11.6214 48.1641H8.81055V50.9749H11.6214V48.1641Z"
        fill="black"
      />
      <path
        d="M14.4319 48.1641H11.6211V50.9749H14.4319V48.1641Z"
        fill="black"
      />
      <path
        d="M22.8655 48.1641H20.0547V50.9749H22.8655V48.1641Z"
        fill="black"
      />
      <path
        d="M28.4866 48.1641H25.6758V50.9749H28.4866V48.1641Z"
        fill="black"
      />
      <path
        d="M31.2971 48.1641H28.4863V50.9749H31.2971V48.1641Z"
        fill="black"
      />
      <path
        d="M34.1077 48.1641H31.2969V50.9749H34.1077V48.1641Z"
        fill="black"
      />
      <path
        d="M36.9202 48.1641H34.1094V50.9749H36.9202V48.1641Z"
        fill="black"
      />
      <path
        d="M42.5413 48.1641H39.7305V50.9749H42.5413V48.1641Z"
        fill="black"
      />
      <path
        d="M48.1624 48.1641H45.3516V50.9749H48.1624V48.1641Z"
        fill="black"
      />
      <path
        d="M65.0276 48.1641H62.2168V50.9749H65.0276V48.1641Z"
        fill="black"
      />
      <path
        d="M67.8382 48.1641H65.0273V50.9749H67.8382V48.1641Z"
        fill="black"
      />
      <path
        d="M70.6487 48.1641H67.8379V50.9749H70.6487V48.1641Z"
        fill="black"
      />
      <path
        d="M73.4592 48.1641H70.6484V50.9749H73.4592V48.1641Z"
        fill="black"
      />
      <path
        d="M81.8909 48.1641H79.0801V50.9749H81.8909V48.1641Z"
        fill="black"
      />
      <path
        d="M90.3245 48.1641H87.5137V50.9749H90.3245V48.1641Z"
        fill="black"
      />
      <path d="M93.135 48.1641H90.3242V50.9749H93.135V48.1641Z" fill="black" />
      <path
        d="M95.9456 48.1641H93.1348V50.9749H95.9456V48.1641Z"
        fill="black"
      />
      <path d="M110 48.1641H107.189V50.9749H110V48.1641Z" fill="black" />
      <path
        d="M11.6214 50.9746H8.81055V53.7854H11.6214V50.9746Z"
        fill="black"
      />
      <path
        d="M14.4319 50.9746H11.6211V53.7854H14.4319V50.9746Z"
        fill="black"
      />
      <path
        d="M22.8655 50.9746H20.0547V53.7854H22.8655V50.9746Z"
        fill="black"
      />
      <path d="M25.676 50.9746H22.8652V53.7854H25.676V50.9746Z" fill="black" />
      <path
        d="M28.4866 50.9746H25.6758V53.7854H28.4866V50.9746Z"
        fill="black"
      />
      <path
        d="M31.2971 50.9746H28.4863V53.7854H31.2971V50.9746Z"
        fill="black"
      />
      <path d="M45.3518 50.9746H42.541V53.7854H45.3518V50.9746Z" fill="black" />
      <path
        d="M48.1624 50.9746H45.3516V53.7854H48.1624V50.9746Z"
        fill="black"
      />
      <path d="M56.594 50.9746H53.7832V53.7854H56.594V50.9746Z" fill="black" />
      <path
        d="M62.2171 50.9746H59.4062V53.7854H62.2171V50.9746Z"
        fill="black"
      />
      <path
        d="M67.8382 50.9746H65.0273V53.7854H67.8382V50.9746Z"
        fill="black"
      />
      <path
        d="M79.0803 50.9746H76.2695V53.7854H79.0803V50.9746Z"
        fill="black"
      />
      <path
        d="M81.8909 50.9746H79.0801V53.7854H81.8909V50.9746Z"
        fill="black"
      />
      <path
        d="M101.569 50.9746H98.7578V53.7854H101.569V50.9746Z"
        fill="black"
      />
      <path
        d="M104.379 50.9746H101.568V53.7854H104.379V50.9746Z"
        fill="black"
      />
      <path d="M107.19 50.9746H104.379V53.7854H107.19V50.9746Z" fill="black" />
      <path d="M8.81081 53.7871H6V56.5979H8.81081V53.7871Z" fill="black" />
      <path
        d="M11.6214 53.7871H8.81055V56.5979H11.6214V53.7871Z"
        fill="black"
      />
      <path
        d="M14.4319 53.7871H11.6211V56.5979H14.4319V53.7871Z"
        fill="black"
      />
      <path
        d="M36.9202 53.7871H34.1094V56.5979H36.9202V53.7871Z"
        fill="black"
      />
      <path d="M39.7288 53.7871H36.918V56.5979H39.7288V53.7871Z" fill="black" />
      <path
        d="M42.5413 53.7871H39.7305V56.5979H42.5413V53.7871Z"
        fill="black"
      />
      <path
        d="M53.7835 53.7871H50.9727V56.5979H53.7835V53.7871Z"
        fill="black"
      />
      <path
        d="M67.8382 53.7871H65.0273V56.5979H67.8382V53.7871Z"
        fill="black"
      />
      <path
        d="M70.6487 53.7871H67.8379V56.5979H70.6487V53.7871Z"
        fill="black"
      />
      <path d="M76.2698 53.7871H73.459V56.5979H76.2698V53.7871Z" fill="black" />
      <path
        d="M84.7014 53.7871H81.8906V56.5979H84.7014V53.7871Z"
        fill="black"
      />
      <path d="M93.135 53.7871H90.3242V56.5979H93.135V53.7871Z" fill="black" />
      <path d="M110 53.7871H107.189V56.5979H110V53.7871Z" fill="black" />
      <path d="M8.81081 56.5938H6V59.4046H8.81081V56.5938Z" fill="black" />
      <path
        d="M11.6214 56.5938H8.81055V59.4046H11.6214V56.5938Z"
        fill="black"
      />
      <path
        d="M22.8655 56.5938H20.0547V59.4046H22.8655V56.5938Z"
        fill="black"
      />
      <path d="M25.676 56.5938H22.8652V59.4046H25.676V56.5938Z" fill="black" />
      <path
        d="M42.5413 56.5938H39.7305V59.4046H42.5413V56.5938Z"
        fill="black"
      />
      <path d="M45.3518 56.5938H42.541V59.4046H45.3518V56.5938Z" fill="black" />
      <path
        d="M48.1624 56.5938H45.3516V59.4046H48.1624V56.5938Z"
        fill="black"
      />
      <path
        d="M50.9729 56.5938H48.1621V59.4046H50.9729V56.5938Z"
        fill="black"
      />
      <path
        d="M53.7835 56.5938H50.9727V59.4046H53.7835V56.5938Z"
        fill="black"
      />
      <path d="M56.594 56.5938H53.7832V59.4046H56.594V56.5938Z" fill="black" />
      <path
        d="M62.2171 56.5938H59.4062V59.4046H62.2171V56.5938Z"
        fill="black"
      />
      <path
        d="M70.6487 56.5938H67.8379V59.4046H70.6487V56.5938Z"
        fill="black"
      />
      <path
        d="M73.4592 56.5938H70.6484V59.4046H73.4592V56.5938Z"
        fill="black"
      />
      <path d="M76.2698 56.5938H73.459V59.4046H76.2698V56.5938Z" fill="black" />
      <path
        d="M81.8909 56.5938H79.0801V59.4046H81.8909V56.5938Z"
        fill="black"
      />
      <path
        d="M84.7014 56.5938H81.8906V59.4046H84.7014V56.5938Z"
        fill="black"
      />
      <path
        d="M87.5139 56.5938H84.7031V59.4046H87.5139V56.5938Z"
        fill="black"
      />
      <path
        d="M98.7561 56.5938H95.9453V59.4046H98.7561V56.5938Z"
        fill="black"
      />
      <path d="M107.19 56.5938H104.379V59.4046H107.19V56.5938Z" fill="black" />
      <path d="M110 56.5938H107.189V59.4046H110V56.5938Z" fill="black" />
      <path d="M11.6214 59.4082H8.81055V62.219H11.6214V59.4082Z" fill="black" />
      <path d="M17.2424 59.4082H14.4316V62.219H17.2424V59.4082Z" fill="black" />
      <path d="M20.053 59.4082H17.2422V62.219H20.053V59.4082Z" fill="black" />
      <path d="M22.8655 59.4082H20.0547V62.219H22.8655V59.4082Z" fill="black" />
      <path d="M31.2971 59.4082H28.4863V62.219H31.2971V59.4082Z" fill="black" />
      <path d="M34.1077 59.4082H31.2969V62.219H34.1077V59.4082Z" fill="black" />
      <path d="M36.9202 59.4082H34.1094V62.219H36.9202V59.4082Z" fill="black" />
      <path d="M39.7288 59.4082H36.918V62.219H39.7288V59.4082Z" fill="black" />
      <path d="M42.5413 59.4082H39.7305V62.219H42.5413V59.4082Z" fill="black" />
      <path d="M53.7835 59.4082H50.9727V62.219H53.7835V59.4082Z" fill="black" />
      <path d="M56.594 59.4082H53.7832V62.219H56.594V59.4082Z" fill="black" />
      <path d="M67.8382 59.4082H65.0273V62.219H67.8382V59.4082Z" fill="black" />
      <path d="M70.6487 59.4082H67.8379V62.219H70.6487V59.4082Z" fill="black" />
      <path d="M73.4592 59.4082H70.6484V62.219H73.4592V59.4082Z" fill="black" />
      <path d="M76.2698 59.4082H73.459V62.219H76.2698V59.4082Z" fill="black" />
      <path d="M90.3245 59.4082H87.5137V62.219H90.3245V59.4082Z" fill="black" />
      <path d="M98.7561 59.4082H95.9453V62.219H98.7561V59.4082Z" fill="black" />
      <path d="M101.569 59.4082H98.7578V62.219H101.569V59.4082Z" fill="black" />
      <path d="M110 59.4082H107.189V62.219H110V59.4082Z" fill="black" />
      <path d="M8.81081 62.2148H6V65.0257H8.81081V62.2148Z" fill="black" />
      <path
        d="M14.4319 62.2148H11.6211V65.0257H14.4319V62.2148Z"
        fill="black"
      />
      <path d="M25.676 62.2148H22.8652V65.0257H25.676V62.2148Z" fill="black" />
      <path
        d="M34.1077 62.2148H31.2969V65.0257H34.1077V62.2148Z"
        fill="black"
      />
      <path
        d="M36.9202 62.2148H34.1094V65.0257H36.9202V62.2148Z"
        fill="black"
      />
      <path d="M45.3518 62.2148H42.541V65.0257H45.3518V62.2148Z" fill="black" />
      <path
        d="M50.9729 62.2148H48.1621V65.0257H50.9729V62.2148Z"
        fill="black"
      />
      <path d="M56.594 62.2148H53.7832V65.0257H56.594V62.2148Z" fill="black" />
      <path
        d="M62.2171 62.2148H59.4062V65.0257H62.2171V62.2148Z"
        fill="black"
      />
      <path
        d="M67.8382 62.2148H65.0273V65.0257H67.8382V62.2148Z"
        fill="black"
      />
      <path
        d="M70.6487 62.2148H67.8379V65.0257H70.6487V62.2148Z"
        fill="black"
      />
      <path
        d="M84.7014 62.2148H81.8906V65.0257H84.7014V62.2148Z"
        fill="black"
      />
      <path
        d="M87.5139 62.2148H84.7031V65.0257H87.5139V62.2148Z"
        fill="black"
      />
      <path
        d="M98.7561 62.2148H95.9453V65.0257H98.7561V62.2148Z"
        fill="black"
      />
      <path
        d="M101.569 62.2148H98.7578V65.0257H101.569V62.2148Z"
        fill="black"
      />
      <path
        d="M14.4319 65.0254H11.6211V67.8362H14.4319V65.0254Z"
        fill="black"
      />
      <path
        d="M22.8655 65.0254H20.0547V67.8362H22.8655V65.0254Z"
        fill="black"
      />
      <path
        d="M28.4866 65.0254H25.6758V67.8362H28.4866V65.0254Z"
        fill="black"
      />
      <path
        d="M31.2971 65.0254H28.4863V67.8362H31.2971V65.0254Z"
        fill="black"
      />
      <path
        d="M36.9202 65.0254H34.1094V67.8362H36.9202V65.0254Z"
        fill="black"
      />
      <path
        d="M42.5413 65.0254H39.7305V67.8362H42.5413V65.0254Z"
        fill="black"
      />
      <path
        d="M50.9729 65.0254H48.1621V67.8362H50.9729V65.0254Z"
        fill="black"
      />
      <path
        d="M53.7835 65.0254H50.9727V67.8362H53.7835V65.0254Z"
        fill="black"
      />
      <path
        d="M59.4046 65.0254H56.5938V67.8362H59.4046V65.0254Z"
        fill="black"
      />
      <path
        d="M62.2171 65.0254H59.4062V67.8362H62.2171V65.0254Z"
        fill="black"
      />
      <path
        d="M65.0276 65.0254H62.2168V67.8362H65.0276V65.0254Z"
        fill="black"
      />
      <path
        d="M73.4592 65.0254H70.6484V67.8362H73.4592V65.0254Z"
        fill="black"
      />
      <path d="M76.2698 65.0254H73.459V67.8362H76.2698V65.0254Z" fill="black" />
      <path
        d="M79.0803 65.0254H76.2695V67.8362H79.0803V65.0254Z"
        fill="black"
      />
      <path
        d="M95.9456 65.0254H93.1348V67.8362H95.9456V65.0254Z"
        fill="black"
      />
      <path
        d="M101.569 65.0254H98.7578V67.8362H101.569V65.0254Z"
        fill="black"
      />
      <path d="M107.19 65.0254H104.379V67.8362H107.19V65.0254Z" fill="black" />
      <path d="M110 65.0254H107.189V67.8362H110V65.0254Z" fill="black" />
      <path d="M8.81081 67.8359H6V70.6467H8.81081V67.8359Z" fill="black" />
      <path
        d="M11.6214 67.8359H8.81055V70.6467H11.6214V67.8359Z"
        fill="black"
      />
      <path d="M20.053 67.8359H17.2422V70.6467H20.053V67.8359Z" fill="black" />
      <path
        d="M22.8655 67.8359H20.0547V70.6467H22.8655V67.8359Z"
        fill="black"
      />
      <path d="M25.676 67.8359H22.8652V70.6467H25.676V67.8359Z" fill="black" />
      <path
        d="M28.4866 67.8359H25.6758V70.6467H28.4866V67.8359Z"
        fill="black"
      />
      <path
        d="M31.2971 67.8359H28.4863V70.6467H31.2971V67.8359Z"
        fill="black"
      />
      <path
        d="M42.5413 67.8359H39.7305V70.6467H42.5413V67.8359Z"
        fill="black"
      />
      <path d="M45.3518 67.8359H42.541V70.6467H45.3518V67.8359Z" fill="black" />
      <path
        d="M48.1624 67.8359H45.3516V70.6467H48.1624V67.8359Z"
        fill="black"
      />
      <path
        d="M50.9729 67.8359H48.1621V70.6467H50.9729V67.8359Z"
        fill="black"
      />
      <path
        d="M53.7835 67.8359H50.9727V70.6467H53.7835V67.8359Z"
        fill="black"
      />
      <path d="M56.594 67.8359H53.7832V70.6467H56.594V67.8359Z" fill="black" />
      <path
        d="M62.2171 67.8359H59.4062V70.6467H62.2171V67.8359Z"
        fill="black"
      />
      <path
        d="M67.8382 67.8359H65.0273V70.6467H67.8382V67.8359Z"
        fill="black"
      />
      <path
        d="M70.6487 67.8359H67.8379V70.6467H70.6487V67.8359Z"
        fill="black"
      />
      <path
        d="M73.4592 67.8359H70.6484V70.6467H73.4592V67.8359Z"
        fill="black"
      />
      <path d="M76.2698 67.8359H73.459V70.6467H76.2698V67.8359Z" fill="black" />
      <path
        d="M79.0803 67.8359H76.2695V70.6467H79.0803V67.8359Z"
        fill="black"
      />
      <path d="M93.135 67.8359H90.3242V70.6467H93.135V67.8359Z" fill="black" />
      <path
        d="M98.7561 67.8359H95.9453V70.6467H98.7561V67.8359Z"
        fill="black"
      />
      <path
        d="M104.379 67.8359H101.568V70.6467H104.379V67.8359Z"
        fill="black"
      />
      <path
        d="M14.4319 70.6484H11.6211V73.4592H14.4319V70.6484Z"
        fill="black"
      />
      <path
        d="M17.2424 70.6484H14.4316V73.4592H17.2424V70.6484Z"
        fill="black"
      />
      <path d="M20.053 70.6484H17.2422V73.4592H20.053V70.6484Z" fill="black" />
      <path
        d="M28.4866 70.6484H25.6758V73.4592H28.4866V70.6484Z"
        fill="black"
      />
      <path
        d="M31.2971 70.6484H28.4863V73.4592H31.2971V70.6484Z"
        fill="black"
      />
      <path
        d="M34.1077 70.6484H31.2969V73.4592H34.1077V70.6484Z"
        fill="black"
      />
      <path
        d="M42.5413 70.6484H39.7305V73.4592H42.5413V70.6484Z"
        fill="black"
      />
      <path d="M45.3518 70.6484H42.541V73.4592H45.3518V70.6484Z" fill="black" />
      <path
        d="M50.9729 70.6484H48.1621V73.4592H50.9729V70.6484Z"
        fill="black"
      />
      <path
        d="M53.7835 70.6484H50.9727V73.4592H53.7835V70.6484Z"
        fill="black"
      />
      <path
        d="M59.4046 70.6484H56.5938V73.4592H59.4046V70.6484Z"
        fill="black"
      />
      <path
        d="M67.8382 70.6484H65.0273V73.4592H67.8382V70.6484Z"
        fill="black"
      />
      <path
        d="M73.4592 70.6484H70.6484V73.4592H73.4592V70.6484Z"
        fill="black"
      />
      <path
        d="M84.7014 70.6484H81.8906V73.4592H84.7014V70.6484Z"
        fill="black"
      />
      <path
        d="M87.5139 70.6484H84.7031V73.4592H87.5139V70.6484Z"
        fill="black"
      />
      <path d="M93.135 70.6484H90.3242V73.4592H93.135V70.6484Z" fill="black" />
      <path
        d="M101.569 70.6484H98.7578V73.4592H101.569V70.6484Z"
        fill="black"
      />
      <path
        d="M104.379 70.6484H101.568V73.4592H104.379V70.6484Z"
        fill="black"
      />
      <path d="M107.19 70.6484H104.379V73.4592H107.19V70.6484Z" fill="black" />
      <path
        d="M11.6214 73.4609H8.81055V76.2717H11.6214V73.4609Z"
        fill="black"
      />
      <path
        d="M17.2444 73.4609H14.4336V76.2717H17.2444V73.4609Z"
        fill="black"
      />
      <path d="M20.053 73.4609H17.2422V76.2717H20.053V73.4609Z" fill="black" />
      <path d="M25.676 73.4609H22.8652V76.2717H25.676V73.4609Z" fill="black" />
      <path
        d="M31.2971 73.4609H28.4863V76.2717H31.2971V73.4609Z"
        fill="black"
      />
      <path d="M39.7288 73.4609H36.918V76.2717H39.7288V73.4609Z" fill="black" />
      <path
        d="M48.1624 73.4609H45.3516V76.2717H48.1624V73.4609Z"
        fill="black"
      />
      <path
        d="M50.9729 73.4609H48.1621V76.2717H50.9729V73.4609Z"
        fill="black"
      />
      <path
        d="M53.7835 73.4609H50.9727V76.2717H53.7835V73.4609Z"
        fill="black"
      />
      <path
        d="M73.4592 73.4609H70.6484V76.2717H73.4592V73.4609Z"
        fill="black"
      />
      <path d="M76.2698 73.4609H73.459V76.2717H76.2698V73.4609Z" fill="black" />
      <path d="M81.8928 73.4609H79.082V76.2717H81.8928V73.4609Z" fill="black" />
      <path
        d="M87.5139 73.4609H84.7031V76.2717H87.5139V73.4609Z"
        fill="black"
      />
      <path
        d="M90.3245 73.4609H87.5137V76.2717H90.3245V73.4609Z"
        fill="black"
      />
      <path
        d="M101.569 73.4609H98.7578V76.2717H101.569V73.4609Z"
        fill="black"
      />
      <path
        d="M104.377 73.4609H101.566V76.2717H104.377V73.4609Z"
        fill="black"
      />
      <path d="M110 73.4609H107.189V76.2717H110V73.4609Z" fill="black" />
      <path
        d="M14.4319 76.2715H11.6211V79.0823H14.4319V76.2715Z"
        fill="black"
      />
      <path
        d="M17.2424 76.2715H14.4316V79.0823H17.2424V76.2715Z"
        fill="black"
      />
      <path d="M20.053 76.2715H17.2422V79.0823H20.053V76.2715Z" fill="black" />
      <path
        d="M28.4866 76.2715H25.6758V79.0823H28.4866V76.2715Z"
        fill="black"
      />
      <path
        d="M31.2971 76.2715H28.4863V79.0823H31.2971V76.2715Z"
        fill="black"
      />
      <path
        d="M36.9202 76.2715H34.1094V79.0823H36.9202V76.2715Z"
        fill="black"
      />
      <path d="M39.7288 76.2715H36.918V79.0823H39.7288V76.2715Z" fill="black" />
      <path
        d="M50.9729 76.2715H48.1621V79.0823H50.9729V76.2715Z"
        fill="black"
      />
      <path
        d="M53.7835 76.2715H50.9727V79.0823H53.7835V76.2715Z"
        fill="black"
      />
      <path
        d="M62.2171 76.2715H59.4062V79.0823H62.2171V76.2715Z"
        fill="black"
      />
      <path
        d="M65.0276 76.2715H62.2168V79.0823H65.0276V76.2715Z"
        fill="black"
      />
      <path
        d="M67.8382 76.2715H65.0273V79.0823H67.8382V76.2715Z"
        fill="black"
      />
      <path
        d="M70.6487 76.2715H67.8379V79.0823H70.6487V76.2715Z"
        fill="black"
      />
      <path
        d="M73.4592 76.2715H70.6484V79.0823H73.4592V76.2715Z"
        fill="black"
      />
      <path d="M76.2698 76.2715H73.459V79.0823H76.2698V76.2715Z" fill="black" />
      <path
        d="M81.8909 76.2715H79.0801V79.0823H81.8909V76.2715Z"
        fill="black"
      />
      <path
        d="M90.3245 76.2715H87.5137V79.0823H90.3245V76.2715Z"
        fill="black"
      />
      <path
        d="M95.9456 76.2715H93.1348V79.0823H95.9456V76.2715Z"
        fill="black"
      />
      <path
        d="M104.379 76.2715H101.568V79.0823H104.379V76.2715Z"
        fill="black"
      />
      <path d="M107.19 76.2715H104.379V79.0823H107.19V76.2715Z" fill="black" />
      <path d="M110 76.2715H107.189V79.0823H110V76.2715Z" fill="black" />
      <path d="M11.6214 79.084H8.81055V81.8948H11.6214V79.084Z" fill="black" />
      <path d="M14.4319 79.084H11.6211V81.8948H14.4319V79.084Z" fill="black" />
      <path d="M17.2424 79.084H14.4316V81.8948H17.2424V79.084Z" fill="black" />
      <path d="M22.8655 79.084H20.0547V81.8948H22.8655V79.084Z" fill="black" />
      <path d="M25.676 79.084H22.8652V81.8948H25.676V79.084Z" fill="black" />
      <path d="M28.4866 79.084H25.6758V81.8948H28.4866V79.084Z" fill="black" />
      <path d="M36.9202 79.084H34.1094V81.8948H36.9202V79.084Z" fill="black" />
      <path d="M39.7288 79.084H36.918V81.8948H39.7288V79.084Z" fill="black" />
      <path d="M42.5413 79.084H39.7305V81.8948H42.5413V79.084Z" fill="black" />
      <path d="M45.3518 79.084H42.541V81.8948H45.3518V79.084Z" fill="black" />
      <path d="M48.1624 79.084H45.3516V81.8948H48.1624V79.084Z" fill="black" />
      <path d="M56.594 79.084H53.7832V81.8948H56.594V79.084Z" fill="black" />
      <path d="M59.4046 79.084H56.5938V81.8948H59.4046V79.084Z" fill="black" />
      <path d="M67.8382 79.084H65.0273V81.8948H67.8382V79.084Z" fill="black" />
      <path d="M73.4592 79.084H70.6484V81.8948H73.4592V79.084Z" fill="black" />
      <path d="M95.9456 79.084H93.1348V81.8948H95.9456V79.084Z" fill="black" />
      <path d="M98.7561 79.084H95.9453V81.8948H98.7561V79.084Z" fill="black" />
      <path d="M107.19 79.084H104.379V81.8948H107.19V79.084Z" fill="black" />
      <path d="M8.81081 81.8945H6V84.7053H8.81081V81.8945Z" fill="black" />
      <path d="M39.7288 81.8945H36.918V84.7053H39.7288V81.8945Z" fill="black" />
      <path d="M56.594 81.8945H53.7832V84.7053H56.594V81.8945Z" fill="black" />
      <path
        d="M65.0276 81.8945H62.2168V84.7053H65.0276V81.8945Z"
        fill="black"
      />
      <path
        d="M70.6487 81.8945H67.8379V84.7053H70.6487V81.8945Z"
        fill="black"
      />
      <path
        d="M73.4592 81.8945H70.6484V84.7053H73.4592V81.8945Z"
        fill="black"
      />
      <path
        d="M81.8909 81.8945H79.0801V84.7053H81.8909V81.8945Z"
        fill="black"
      />
      <path
        d="M84.7014 81.8945H81.8906V84.7053H84.7014V81.8945Z"
        fill="black"
      />
      <path
        d="M90.3245 81.8945H87.5137V84.7053H90.3245V81.8945Z"
        fill="black"
      />
      <path
        d="M95.9456 81.8945H93.1348V84.7053H95.9456V81.8945Z"
        fill="black"
      />
      <path
        d="M98.7561 81.8945H95.9453V84.7053H98.7561V81.8945Z"
        fill="black"
      />
      <path
        d="M101.569 81.8945H98.7578V84.7053H101.569V81.8945Z"
        fill="black"
      />
      <path d="M107.19 81.8945H104.379V84.7053H107.19V81.8945Z" fill="black" />
      <path d="M110 81.8945H107.189V84.7053H110V81.8945Z" fill="black" />
      <path
        d="M22.8655 84.7031H20.0547V87.5139H22.8655V84.7031Z"
        fill="black"
      />
      <path d="M25.676 84.7031H22.8652V87.5139H25.676V84.7031Z" fill="black" />
      <path
        d="M39.7307 84.7031H36.9199V87.5139H39.7307V84.7031Z"
        fill="black"
      />
      <path
        d="M42.5413 84.7031H39.7305V87.5139H42.5413V84.7031Z"
        fill="black"
      />
      <path
        d="M50.9729 84.7031H48.1621V87.5139H50.9729V84.7031Z"
        fill="black"
      />
      <path
        d="M53.7835 84.7031H50.9727V87.5139H53.7835V84.7031Z"
        fill="black"
      />
      <path
        d="M59.4046 84.7031H56.5938V87.5139H59.4046V84.7031Z"
        fill="black"
      />
      <path
        d="M62.2151 84.7031H59.4043V87.5139H62.2151V84.7031Z"
        fill="black"
      />
      <path
        d="M65.0276 84.7031H62.2168V87.5139H65.0276V84.7031Z"
        fill="black"
      />
      <path
        d="M67.8382 84.7031H65.0273V87.5139H67.8382V84.7031Z"
        fill="black"
      />
      <path d="M76.2698 84.7031H73.459V87.5139H76.2698V84.7031Z" fill="black" />
      <path
        d="M79.0803 84.7031H76.2695V87.5139H79.0803V84.7031Z"
        fill="black"
      />
      <path
        d="M87.5139 84.7031H84.7031V87.5139H87.5139V84.7031Z"
        fill="black"
      />
      <path
        d="M90.3245 84.7031H87.5137V87.5139H90.3245V84.7031Z"
        fill="black"
      />
      <path d="M93.135 84.7031H90.3242V87.5139H93.135V84.7031Z" fill="black" />
      <path
        d="M95.9456 84.7031H93.1348V87.5139H95.9456V84.7031Z"
        fill="black"
      />
      <path
        d="M98.7561 84.7031H95.9453V87.5139H98.7561V84.7031Z"
        fill="black"
      />
      <path d="M110 84.7031H107.189V87.5139H110V84.7031Z" fill="black" />
      <path
        d="M31.2971 87.5137H28.4863V90.3245H31.2971V87.5137Z"
        fill="black"
      />
      <path d="M45.3518 87.5137H42.541V90.3245H45.3518V87.5137Z" fill="black" />
      <path
        d="M50.9729 87.5137H48.1621V90.3245H50.9729V87.5137Z"
        fill="black"
      />
      <path
        d="M53.7835 87.5137H50.9727V90.3245H53.7835V87.5137Z"
        fill="black"
      />
      <path d="M56.594 87.5137H53.7832V90.3245H56.594V87.5137Z" fill="black" />
      <path
        d="M59.4046 87.5137H56.5938V90.3245H59.4046V87.5137Z"
        fill="black"
      />
      <path
        d="M73.4592 87.5137H70.6484V90.3245H73.4592V87.5137Z"
        fill="black"
      />
      <path d="M76.2698 87.5137H73.459V90.3245H76.2698V87.5137Z" fill="black" />
      <path
        d="M87.5139 87.5137H84.7031V90.3245H87.5139V87.5137Z"
        fill="black"
      />
      <path
        d="M98.7561 87.5137H95.9453V90.3245H98.7561V87.5137Z"
        fill="black"
      />
      <path
        d="M101.569 87.5137H98.7578V90.3245H101.569V87.5137Z"
        fill="black"
      />
      <path
        d="M104.379 87.5137H101.568V90.3245H104.379V87.5137Z"
        fill="black"
      />
      <path d="M107.19 87.5137H104.379V90.3245H107.19V87.5137Z" fill="black" />
      <path d="M110 87.5137H107.189V90.3245H110V87.5137Z" fill="black" />
      <path d="M31.2971 90.3262H28.4863V93.137H31.2971V90.3262Z" fill="black" />
      <path d="M42.5413 90.3262H39.7305V93.137H42.5413V90.3262Z" fill="black" />
      <path d="M45.3518 90.3262H42.541V93.137H45.3518V90.3262Z" fill="black" />
      <path d="M50.9729 90.3262H48.1621V93.137H50.9729V90.3262Z" fill="black" />
      <path d="M53.7835 90.3262H50.9727V93.137H53.7835V90.3262Z" fill="black" />
      <path d="M56.594 90.3262H53.7832V93.137H56.594V90.3262Z" fill="black" />
      <path d="M62.2171 90.3262H59.4062V93.137H62.2171V90.3262Z" fill="black" />
      <path d="M67.8382 90.3262H65.0273V93.137H67.8382V90.3262Z" fill="black" />
      <path d="M70.6487 90.3262H67.8379V93.137H70.6487V90.3262Z" fill="black" />
      <path d="M76.2698 90.3262H73.459V93.137H76.2698V90.3262Z" fill="black" />
      <path d="M79.0803 90.3262H76.2695V93.137H79.0803V90.3262Z" fill="black" />
      <path d="M81.8909 90.3262H79.0801V93.137H81.8909V90.3262Z" fill="black" />
      <path d="M87.5139 90.3262H84.7031V93.137H87.5139V90.3262Z" fill="black" />
      <path d="M93.135 90.3262H90.3242V93.137H93.135V90.3262Z" fill="black" />
      <path d="M98.7561 90.3262H95.9453V93.137H98.7561V90.3262Z" fill="black" />
      <path d="M101.569 90.3262H98.7578V93.137H101.569V90.3262Z" fill="black" />
      <path d="M107.19 90.3262H104.379V93.137H107.19V90.3262Z" fill="black" />
      <path d="M110 90.3262H107.189V93.137H110V90.3262Z" fill="black" />
      <path
        d="M36.9202 93.1367H34.1094V95.9475H36.9202V93.1367Z"
        fill="black"
      />
      <path d="M39.7288 93.1367H36.918V95.9475H39.7288V93.1367Z" fill="black" />
      <path
        d="M42.5413 93.1367H39.7305V95.9475H42.5413V93.1367Z"
        fill="black"
      />
      <path d="M45.3518 93.1367H42.541V95.9475H45.3518V93.1367Z" fill="black" />
      <path
        d="M48.1624 93.1367H45.3516V95.9475H48.1624V93.1367Z"
        fill="black"
      />
      <path
        d="M50.9729 93.1367H48.1621V95.9475H50.9729V93.1367Z"
        fill="black"
      />
      <path d="M56.594 93.1367H53.7832V95.9475H56.594V93.1367Z" fill="black" />
      <path
        d="M62.2171 93.1367H59.4062V95.9475H62.2171V93.1367Z"
        fill="black"
      />
      <path
        d="M67.8382 93.1367H65.0273V95.9475H67.8382V93.1367Z"
        fill="black"
      />
      <path
        d="M70.6487 93.1367H67.8379V95.9475H70.6487V93.1367Z"
        fill="black"
      />
      <path
        d="M81.8909 93.1367H79.0801V95.9475H81.8909V93.1367Z"
        fill="black"
      />
      <path
        d="M84.7014 93.1367H81.8906V95.9475H84.7014V93.1367Z"
        fill="black"
      />
      <path
        d="M87.5139 93.1367H84.7031V95.9475H87.5139V93.1367Z"
        fill="black"
      />
      <path
        d="M98.7561 93.1367H95.9453V95.9475H98.7561V93.1367Z"
        fill="black"
      />
      <path
        d="M101.569 93.1367H98.7578V95.9475H101.569V93.1367Z"
        fill="black"
      />
      <path d="M110 93.1367H107.189V95.9475H110V93.1367Z" fill="black" />
      <path d="M56.594 95.9473H53.7832V98.7581H56.594V95.9473Z" fill="black" />
      <path
        d="M67.8382 95.9473H65.0273V98.7581H67.8382V95.9473Z"
        fill="black"
      />
      <path
        d="M70.6487 95.9473H67.8379V98.7581H70.6487V95.9473Z"
        fill="black"
      />
      <path d="M76.2698 95.9473H73.459V98.7581H76.2698V95.9473Z" fill="black" />
      <path d="M81.8928 95.9473H79.082V98.7581H81.8928V95.9473Z" fill="black" />
      <path
        d="M87.5139 95.9473H84.7031V98.7581H87.5139V95.9473Z"
        fill="black"
      />
      <path
        d="M90.3245 95.9473H87.5137V98.7581H90.3245V95.9473Z"
        fill="black"
      />
      <path d="M93.135 95.9473H90.3242V98.7581H93.135V95.9473Z" fill="black" />
      <path
        d="M95.9456 95.9473H93.1348V98.7581H95.9456V95.9473Z"
        fill="black"
      />
      <path
        d="M98.7561 95.9473H95.9453V98.7581H98.7561V95.9473Z"
        fill="black"
      />
      <path
        d="M101.569 95.9473H98.7578V98.7581H101.569V95.9473Z"
        fill="black"
      />
      <path d="M107.19 95.9473H104.379V98.7581H107.19V95.9473Z" fill="black" />
      <path d="M110 95.9473H107.189V98.7581H110V95.9473Z" fill="black" />
      <path
        d="M31.2971 98.7539H28.4863V101.565H31.2971V98.7539Z"
        fill="black"
      />
      <path
        d="M48.1624 98.7539H45.3516V101.565H48.1624V98.7539Z"
        fill="black"
      />
      <path
        d="M53.7835 98.7539H50.9727V101.565H53.7835V98.7539Z"
        fill="black"
      />
      <path
        d="M59.4046 98.7539H56.5938V101.565H59.4046V98.7539Z"
        fill="black"
      />
      <path
        d="M62.2171 98.7539H59.4062V101.565H62.2171V98.7539Z"
        fill="black"
      />
      <path
        d="M65.0276 98.7539H62.2168V101.565H65.0276V98.7539Z"
        fill="black"
      />
      <path
        d="M67.8382 98.7539H65.0273V101.565H67.8382V98.7539Z"
        fill="black"
      />
      <path d="M76.2698 98.7539H73.459V101.565H76.2698V98.7539Z" fill="black" />
      <path
        d="M79.0803 98.7539H76.2695V101.565H79.0803V98.7539Z"
        fill="black"
      />
      <path
        d="M84.7014 98.7539H81.8906V101.565H84.7014V98.7539Z"
        fill="black"
      />
      <path
        d="M87.5139 98.7539H84.7031V101.565H87.5139V98.7539Z"
        fill="black"
      />
      <path d="M93.135 98.7539H90.3242V101.565H93.135V98.7539Z" fill="black" />
      <path
        d="M98.7561 98.7539H95.9453V101.565H98.7561V98.7539Z"
        fill="black"
      />
      <path
        d="M31.2971 101.572H28.4863V104.383H31.2971V101.572Z"
        fill="black"
      />
      <path
        d="M42.5413 101.572H39.7305V104.383H42.5413V101.572Z"
        fill="black"
      />
      <path
        d="M53.7835 101.572H50.9727V104.383H53.7835V101.572Z"
        fill="black"
      />
      <path d="M56.594 101.572H53.7832V104.383H56.594V101.572Z" fill="black" />
      <path
        d="M59.4046 101.572H56.5938V104.383H59.4046V101.572Z"
        fill="black"
      />
      <path
        d="M62.2171 101.572H59.4062V104.383H62.2171V101.572Z"
        fill="black"
      />
      <path
        d="M65.0276 101.572H62.2168V104.383H65.0276V101.572Z"
        fill="black"
      />
      <path
        d="M73.4592 101.572H70.6484V104.383H73.4592V101.572Z"
        fill="black"
      />
      <path d="M76.2698 101.572H73.459V104.383H76.2698V101.572Z" fill="black" />
      <path
        d="M79.0803 101.572H76.2695V104.383H79.0803V101.572Z"
        fill="black"
      />
      <path
        d="M84.7014 101.572H81.8906V104.383H84.7014V101.572Z"
        fill="black"
      />
      <path
        d="M87.5139 101.572H84.7031V104.383H87.5139V101.572Z"
        fill="black"
      />
      <path d="M93.135 101.572H90.3242V104.383H93.135V101.572Z" fill="black" />
      <path
        d="M95.9456 101.572H93.1348V104.383H95.9456V101.572Z"
        fill="black"
      />
      <path
        d="M98.7561 101.572H95.9453V104.383H98.7561V101.572Z"
        fill="black"
      />
      <path d="M107.19 101.572H104.379V104.383H107.19V101.572Z" fill="black" />
      <path d="M39.7288 104.377H36.918V107.188H39.7288V104.377Z" fill="black" />
      <path
        d="M42.5413 104.377H39.7305V107.188H42.5413V104.377Z"
        fill="black"
      />
      <path d="M45.3518 104.377H42.541V107.188H45.3518V104.377Z" fill="black" />
      <path
        d="M48.1624 104.377H45.3516V107.188H48.1624V104.377Z"
        fill="black"
      />
      <path
        d="M50.9729 104.377H48.1621V107.188H50.9729V104.377Z"
        fill="black"
      />
      <path
        d="M53.7835 104.377H50.9727V107.188H53.7835V104.377Z"
        fill="black"
      />
      <path
        d="M62.2171 104.377H59.4062V107.188H62.2171V104.377Z"
        fill="black"
      />
      <path
        d="M65.0276 104.377H62.2168V107.188H65.0276V104.377Z"
        fill="black"
      />
      <path
        d="M70.6487 104.377H67.8379V107.188H70.6487V104.377Z"
        fill="black"
      />
      <path
        d="M79.0803 104.377H76.2695V107.188H79.0803V104.377Z"
        fill="black"
      />
      <path d="M81.8928 104.377H79.082V107.188H81.8928V104.377Z" fill="black" />
      <path
        d="M90.3245 104.377H87.5137V107.188H90.3245V104.377Z"
        fill="black"
      />
      <path
        d="M98.7561 104.377H95.9453V107.188H98.7561V104.377Z"
        fill="black"
      />
      <path
        d="M101.569 104.377H98.7578V107.188H101.569V104.377Z"
        fill="black"
      />
      <path
        d="M104.377 104.377H101.566V107.188H104.377V104.377Z"
        fill="black"
      />
      <path d="M36.9202 107.189H34.1094V110H36.9202V107.189Z" fill="black" />
      <path d="M48.1624 107.189H45.3516V110H48.1624V107.189Z" fill="black" />
      <path d="M50.9729 107.189H48.1621V110H50.9729V107.189Z" fill="black" />
      <path d="M65.0276 107.189H62.2168V110H65.0276V107.189Z" fill="black" />
      <path d="M67.8382 107.189H65.0273V110H67.8382V107.189Z" fill="black" />
      <path d="M79.0803 107.189H76.2695V110H79.0803V107.189Z" fill="black" />
      <path d="M93.135 107.189H90.3242V110H93.135V107.189Z" fill="black" />
      <path d="M95.9456 107.189H93.1348V110H95.9456V107.189Z" fill="black" />
      <path d="M104.379 107.189H101.568V110H104.379V107.189Z" fill="black" />
      <path d="M107.19 107.189H104.379V110H107.19V107.189Z" fill="black" />
      <path d="M110 107.189H107.189V110H110V107.189Z" fill="black" />
      <path
        d="M22.7243 6H8.95135H6V8.95135V22.7243V25.6757H8.95135H22.7243H25.6757V22.7243V8.95135V6H22.7243ZM22.7243 22.7243H8.95135V8.95135H22.7243V22.7243Z"
        fill="black"
      />
      <path
        d="M107.049 6H93.2756H90.3242V8.95135V22.7243V25.6757H93.2756H107.049H110V22.7243V8.95135V6H107.049ZM107.049 22.7243H93.2756V8.95135H107.049V22.7243Z"
        fill="black"
      />
      <path
        d="M22.7243 90.3242H8.95135H6V93.2756V107.049V110H8.95135H22.7243H25.6757V107.049V93.2756V90.3242H22.7243ZM22.7243 107.049H8.95135V93.2756H22.7243V107.049Z"
        fill="black"
      />
      <path d="M20.0535 11.625H11.6211V20.0574H20.0535V11.625Z" fill="black" />
      <path d="M104.378 11.625H95.9453V20.0574H104.378V11.625Z" fill="black" />
      <path d="M20.0535 95.9473H11.6211V104.38H20.0535V95.9473Z" fill="black" />
      <rect
        x="42.541"
        y="42.543"
        width="30.9189"
        height="30.9189"
        fill="url(#pattern0_6568_35766)"
      />
      <defs>
        <pattern
          id="pattern0_6568_35766"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_6568_35766" transform="scale(0.00324675)" />
        </pattern>
        <image
          id="image0_6568_35766"
          width="308"
          height="308"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};
